import { EmptyState } from "@arcadeai/design-system/components/ui/molecules/empty-state";
import { McpSectionNavHeader } from "@arcadeai/design-system/components/ui/molecules/mcp-server-picker/section-nav-header";
import { McpToolkitGroupHeader } from "@arcadeai/design-system/components/ui/molecules/mcp-server-picker/toolkit-group-header";
import { countSelectedTools } from "../selection";
import type { McpServer, McpTool } from "../types";
import { ToolCardGrid } from "./tool-groups";

export function ToolsView({
  onBack,
  onToggleTool,
  scrollContainer = null,
  selected,
  server,
  tools,
}: {
  onBack: () => void;
  onToggleTool: (fqn: string) => void;
  scrollContainer?: HTMLElement | null;
  selected: Set<string>;
  server: McpServer;
  /**
   * Tools to render — the tools-view search's result. Defaults to the server's
   * full list. The header count always reflects the server total, not this.
   */
  tools?: McpTool[];
}) {
  const visibleTools = tools ?? server.tools;
  const selectedCount = countSelectedTools(server.tools, selected);
  return (
    <div className="space-y-3">
      <McpSectionNavHeader
        identity={
          <McpToolkitGroupHeader
            count={
              <span>
                {selectedCount} of {server.tools.length} selected
              </span>
            }
            name={server.displayName}
            toolkitId={server.name}
          />
        }
        onBack={onBack}
      />
      {renderTools({
        onToggleTool,
        scrollContainer,
        selected,
        serverToolCount: server.tools.length,
        visibleTools,
      })}
    </div>
  );
}

function renderTools({
  onToggleTool,
  scrollContainer,
  selected,
  serverToolCount,
  visibleTools,
}: {
  onToggleTool: (fqn: string) => void;
  scrollContainer: HTMLElement | null;
  selected: Set<string>;
  serverToolCount: number;
  visibleTools: McpTool[];
}) {
  if (visibleTools.length > 0) {
    return (
      <ToolCardGrid
        onToggleTool={onToggleTool}
        scrollContainer={scrollContainer}
        selected={selected}
        tools={visibleTools}
      />
    );
  }
  // Distinguish a server with no tools at all from a search that matched none.
  if (serverToolCount === 0) {
    return (
      <EmptyState
        description="This MCP server doesn't expose any tools."
        role="status"
        title="No tools available"
      />
    );
  }
  return <EmptyState role="status" title="No tools match" />;
}
